function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Checklist Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M3,10.75 C3.27614237,10.75 3.5,10.9738576 3.5,11.25 L3.5,13.25 C3.5,13.5261424 3.27614237,13.75 3,13.75 L1,13.75 C0.723857625,13.75 0.5,13.5261424 0.5,13.25 L0.5,11.25 C0.5,10.9738576 0.723857625,10.75 1,10.75 L3,10.75 Z M2.5,11.75 L1.5,11.75 L1.5,12.75 L2.5,12.75 L2.5,11.75 Z M16,11.75 C16.2761424,11.75 16.5,11.9738576 16.5,12.25 C16.5,12.5261424 16.2761424,12.75 16,12.75 L6,12.75 C5.72385763,12.75 5.5,12.5261424 5.5,12.25 C5.5,11.9738576 5.72385763,11.75 6,11.75 L16,11.75 Z M3,5.75 C3.27614237,5.75 3.5,5.97385763 3.5,6.25 L3.5,8.25 C3.5,8.52614237 3.27614237,8.75 3,8.75 L1,8.75 C0.723857625,8.75 0.5,8.52614237 0.5,8.25 L0.5,6.25 C0.5,5.97385763 0.723857625,5.75 1,5.75 L3,5.75 Z M2.5,6.75 L1.5,6.75 L1.5,7.75 L2.5,7.75 L2.5,6.75 Z M16,6.75 C16.2761424,6.75 16.5,6.97385763 16.5,7.25 C16.5,7.52614237 16.2761424,7.75 16,7.75 L6,7.75 C5.72385763,7.75 5.5,7.52614237 5.5,7.25 C5.5,6.97385763 5.72385763,6.75 6,6.75 L16,6.75 Z M3.85355339,0.146446609 C4.04881554,0.341708755 4.04881554,0.658291245 3.85355339,0.853553391 L1.60355339,3.10355339 C1.40829124,3.29881554 1.09170876,3.29881554 0.896446609,3.10355339 L0.146446609,2.35355339 C-0.0488155365,2.15829124 -0.0488155365,1.84170876 0.146446609,1.64644661 C0.341708755,1.45118446 0.658291245,1.45118446 0.853553391,1.64644661 L1.25,2.04289322 L3.14644661,0.146446609 C3.34170876,-0.0488155365 3.65829124,-0.0488155365 3.85355339,0.146446609 Z M16,1.75 C16.2761424,1.75 16.5,1.97385763 16.5,2.25 C16.5,2.52614237 16.2761424,2.75 16,2.75 L6,2.75 C5.72385763,2.75 5.5,2.52614237 5.5,2.25 C5.5,1.97385763 5.72385763,1.75 6,1.75 L16,1.75 Z",
  id: "checklist-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "checklist-Icon/Global/Checklist",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "checklist-Swatches/Midnight",
  transform: "translate(4.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "checklist-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#checklist-path-1"
})));

var SvgChecklist = function SvgChecklist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecklist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checklist.5e0be854.svg";
export { ForwardRef as ReactComponent };